import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { HashRouter as Router } from "react-router-dom";
import { LoginProvider } from "./Components/Contexts/LoginContext";
import { UserProvider } from "./Components/Contexts/UserContext";
import { ModalsProvider } from "./Components/Contexts/ModalsContext";

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <LoginProvider>
        <UserProvider>
          <ModalsProvider>
            <App />
          </ModalsProvider>
        </UserProvider>
      </LoginProvider>
    </Router>
  </React.StrictMode>,
  document.getElementById("root")
);
